"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.startRegistrationCommand = exports.buildStartRegistrationRedirectUrl = void 0;var _const = require("../const");
var _browser = require("../utils/browser");
var _url = require("../utils/url");


/**
 * Starts the user registration process that was initiated from a client portal's system
 * @param config
 * @param encodedClientState - encoded client state - will be returned in response
 * @param token - user registration token
 */
const startRegistrationCommand = (config, token, encodedClientState) => {
  const url = buildStartRegistrationRedirectUrl(config, token, encodedClientState);
  (0, _browser.launchUri)(url);
};exports.startRegistrationCommand = startRegistrationCommand;

const buildStartRegistrationRedirectUrl = (config, token, encodedClientState) => {
  const params = {
    ...{ [_const.QS_REGISTRATION_TOKEN]: token },
    ...(encodedClientState ? { [_const.QS_STATE]: encodedClientState } : {})
  };
  return (0, _url.buildUrlFromConfig)(config, _const.PATH_START_REGISTRATION, params);
};exports.buildStartRegistrationRedirectUrl = buildStartRegistrationRedirectUrl;